import { useCallback, useEffect, useState } from 'react';
import type { GetGoodsCouponResponse, GoodsCoupon } from 'shared/src/api';
import { bridge, isNil } from 'shared/src/utils';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';

export const useLogViewCouponListModal = (coupons?: {
  allCoupons: GetGoodsCouponResponse;
  cartCoupons: GoodsCoupon[];
  marketCoupons: GoodsCoupon[];
}) => {
  const { data: goodsBasic } = useGoodsBasic();
  const [isLogged, setIsLogged] = useState(false);

  const logCoupons = useCallback(() => {
    if (isNil(coupons)) return;
    if (isNil(goodsBasic)) return;
    if (isLogged) return;

    const downloadableCoupons = coupons.allCoupons.filter(
      coupon => !coupon.is_issued,
    );
    const downloadableMarketCoupons = coupons.marketCoupons.filter(
      coupon => !coupon.is_issued,
    );
    //
    bridge.logAnalyticsEvent({
      name: 'VIEW_COUPON_LIST_MODAL',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
        DOWNLOADABLE_COUPON_COUNT: coupons.allCoupons.length,
        DOWNLOADABLE_MARKET_COUPON_COUNT: coupons.marketCoupons.length,
        GOODS_NAME: goodsBasic.name,
        GOODS_SNO: goodsBasic.sno.toString(),
        //TODO 추가
        // HAS_STACKABLE_COUPON:
        MARKET_NAME: goodsBasic.market.name,
        MARKET_SNO: goodsBasic.market.sno.toString(),
        USABLE_COUPON_COUNT: downloadableCoupons.length,
        USABLE_MARKET_COUPON_COUNT: downloadableMarketCoupons.length,
      },
    });
    setIsLogged(true);
  }, [coupons, isLogged, goodsBasic]);

  useEffect(() => {
    logCoupons();
  }, [logCoupons]);
};
